import React from 'react'
import { home_grid } from '../../Images'
import css from './HomePage.module.scss'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { battery_blank, battery_charged } from '../../Images/Icons'
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { battery_charging } from '../../Images/Icons'
import { useSelector, useDispatch } from 'react-redux';
import { GetBattery } from '../../Services/HomeServices'

const GridEnergyHybrid = (props) => {
    const navigation = useNavigate();
    const Step = useSelector(state => state.Step)
    const [showBottomSheet, hideBottomSheet] = useOutletContext();
    const station_get = localStorage.getItem("station_get");

    const onBattery = async () => {
        try {
            let result = await GetBattery(station_get);
            // console.log('result', result.data.return.battery)
            showBottomSheet('',
                <div style={{ textAlign: 'center', margin: '0 20px', marginTop: -40 }}>
                    <div style={{ height: 292, height: 150, }}>
                        <img src={battery_blank} alt="" style={{ width: 292, height: 180 }} />
                    </div>
                    <div style={{ height: 74, display: 'flex', justifyContent: 'space-between', background: 'white', marginTop: 40, borderRadius: 8 }}>
                        <div style={{ flex: 1, textAlign: 'center' }}>
                            <div style={{ fontSize: 24, fontWeight: 500, color: '#292929', marginTop: 10 }}>{result.data.return.battery.charge_today} <span style={{ fontSize: 14, fontWeight: 500, color: '#BFBFBF' }}>kWh</span></div>
                            <div style={{ fontSize: 12, fontWeight: 400, color: '#6a6a6a' }}>Energy charged today</div>
                        </div>
                        <div style={{ flex: 1, textAlign: 'center' }}>
                            <div style={{ fontSize: 24, fontWeight: 500, color: '#292929', marginTop: 10 }}>{result.data.return.battery.discharge_today} <span style={{ fontSize: 14, fontWeight: 500, color: '#BFBFBF' }}>kWh</span></div>
                            <div style={{ fontSize: 12, fontWeight: 400, color: '#6a6a6a' }}>Energy discharged today</div>
                        </div>
                    </div>
                    <div style={{ height: 74, display: 'flex', justifyContent: 'space-between', marginTop: 10, marginBottom: 30, borderRadius: 8 }}>
                        <div style={{ flex: 1, textAlign: 'center', background: 'white', marginRight: 4, borderRadius: 6 }}>
                            <div style={{ fontSize: 12, fontWeight: 400, color: '#6a6a6a', marginTop: 10 }}>Remaining Capacity</div>
                            <div style={{
                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                height: 32, fontSize: 16, fontWeight: 700, color: '#292929', marginTop: 4
                            }}>{result.data.return.battery.remaining_capacity}%
                                <div style={{ marginLeft: 4 }}><img src={battery_charged} style={{ width: 32, height: 32 }} /></div>
                            </div>
                        </div>
                        <div style={{ flex: 1, textAlign: 'center', background: 'white', marginLeft: 4, borderRadius: 8 }}>
                            <div style={{ fontSize: 12, fontWeight: 400, color: '#6a6a6a', marginTop: 10 }}>Power (Charging)</div>
                            <div style={{
                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                height: 32, fontSize: 16, fontWeight: 700, color: '#292929', marginTop: 4
                            }}>{result.data.return.battery.power}kW</div>
                        </div>
                    </div>
                </div>);
        } catch (error) {
          console.error('Error fetching dataStation:', error);
        }


    }
    useEffect(() => {
        if(Step.coachmark == 9){
            onBattery()
        }
        console.log('dicomponent',props.data.return.pv.active_power)
    }, [Step.coachmark]);

    return (
        <div className={css.grid_energy}>
            <div className={css.image} style={{ position: 'relative' }}>
                {/* <img src={home_grid} /> */}
                <img src="/monitoring/assets/Hybrid_Battery-to-PV.gif" />
                {/* <video autoPlay loop muted style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                    <source src="/monitoring/assets/infographic-solarpanel-hybrid-1.webm" type="video/mp4" />
                </video> */}
            </div>
            <div className={css.persen}>
                {props.data.return.battery.level}%<img src={battery_charging}/>
            </div> 

            <div className={css.home_value1} onClick={()=> navigation('/home/statistic')}>
                PV
                <div>
                    <label>{props.data.return.pv.active_power.toFixed(2)} </label>
                    <span> kW</span>
                </div>
            </div>
            <div className={css.home_value2}>
                <div className={css.battery_button} onClick={onBattery}></div>
                <div>Battery<i className='fi-rr-angle-small-right'></i></div>
                <div>
                    <label>{props.data.return.battery.power.toFixed(2)} </label>
                    <span> kW</span>
                </div>
            </div>
            <div className={css.home_value3}>
                Consumption
                <div>
                    <label>{props.data.return.consumption.total.toFixed(2)} </label>
                    <span> kW</span>
                </div>
            </div>
            <div className={css.home_value4}>
                <div>Grid</div>
                <div>
                    <label>{props.data.return.grid.power.toFixed(2)}</label>
                    <span> kW</span>
                </div>
            </div>
        </div>
    )
}

export default GridEnergyHybrid